export default __webpack_public_path__ + "static/media/entrance-bg.f3aa5721.jpg";